// components/chat/chat-input/LexicalSendOnEnter.tsx
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { KEY_ENTER_COMMAND, COMMAND_PRIORITY_LOW, $getRoot } from "lexical";

export const LexicalSendOnEnter: React.FC<{
  onSend: (text: string) => void;
}> = ({ onSend }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event: KeyboardEvent) => {
        if (!event.shiftKey) {
          event.preventDefault();
          const text = editor.getEditorState().read(() => {
            return $getRoot().getTextContent();
          });
          onSend(text);
          // Clear editor after sending
          editor.update(() => {
            const root = $getRoot();
            root.clear();
          });
          return true;
        }
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor, onSend]);

  return null;
};
